export const SUBSCRIPTION_STATUSES = {
  available: 'Available',
  notAvailable: 'NotAvailable',
  connected: 'Connected',
  suspended: 'Suspended',
  pending: 'Pending',
};

export const getStatusFromLocalStorage = () => localStorage.getItem('yaPlusSbscriptionStatus');
